<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--down" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.75 9.98 12 14.93 7.25 9.98" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
</template>